import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import * as moment from 'moment';
import { ICalendarData } from '../../manage-calendar/manage-calendar.interface';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';


export interface CalendarDate {
  mDate: moment.Moment;
  idTipus?: number; //per lligar amb taula tipus de dies: personal, festiu, metge, baixa, viatge....
  today?: boolean;
  observacions?: string;
}

@Injectable()
export class ManageCalendariService {

  public getCalendari(usuari: string, mesAny: string): Observable<Array<any>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'calendari/' + usuari + "/data/"+mesAny)
      .pipe(map(response => response || {}));
  }
  
  public saveCalendari(usuari: string, calendari: CalendarDate[]): Observable<any> {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'calendari/' + usuari, calendari)
      .pipe(map(response => response|| {}));
  }

  public getTipusDies(): Observable<Array<any>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'calendari/tipus/')
      .pipe(map(response => response || {}));
  }

  public getTotalsTipusDies(usuari,year): Observable<Array<any>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'calendari/totals/'+usuari+"/"+year)
      .pipe(map(response => response || {}));
  }
  constructor(protected authHttp: HttpClient) {}

}
